import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Pitches from "@/pages/Pitches";
import Live from "@/pages/Live";
import Events from "@/pages/Events";
import Rankings from "@/pages/Rankings";
import Pricing from "@/pages/Pricing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import PitchDetail from "@/pages/PitchDetail";

function App() {
  return (
    <div className="App min-h-screen bg-[#050505] text-white overflow-x-clip">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pitches" element={<Pitches />} />
            <Route path="/pitch/:id" element={<PitchDetail />} />
            <Route path="/live" element={<Live />} />
            <Route path="/events" element={<Events />} />
            <Route path="/rankings" element={<Rankings />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Register />} />
            <Route path="/dashboard" element={<Dashboard />} />
          </Routes>
          <Footer />
          <Toaster position="bottom-right" theme="dark" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
